import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { Ability } from '@casl/ability';

export const AbilityContext = createContext();
export const Can = createContextualCan(AbilityContext.Consumer);

let initialAbilities = [];
try {
    const storedAbilities = localStorage.getItem('abilities');
    if (storedAbilities) {
        initialAbilities = JSON.parse(storedAbilities);
    }
} catch (e) {
    console.error("Failed to parse abilities", e);
}

export const defaultAbility = new Ability(initialAbilities);
